var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dm-body"},[(!_vm.sel_user.loggedIn)?[(_vm.showLogin)?_c('div',[_c('Login')],1):_vm._e()]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }